import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-alert-success-modal',
  templateUrl: './alert-success.component.html',
  styleUrls: ['./alert-success.component.scss']
})
export class AlertSuccessModalComponent implements OnInit {
    @Input() title: string = '';
    @Input() subTitle: string = '';

    constructor(private modalService: NgbActiveModal) {}

    ngOnInit(): void {
        
    }

    close() {
      this.modalService.dismiss(false);
    }
}
